import React from "react";
import ReactDOM from "react-dom";

import 'index.css';

import App from 'app/App';

import { ContextProvider } from 'shared/contexts/ContextProvider';
import { LayoutProvider } from 'shared/contexts/LayoutContext';

// registerLicense('Ngo9BigBOggjHTQxAR8/V1NAaF1cVWhIfEx1RHxQdld5ZFRHallYTnNWUj0eQnxTdEFjWn9ccXRXRGVZU0J+Xg==');

ReactDOM.render(
  <ContextProvider>
    <LayoutProvider>
      <App />
    </LayoutProvider>
  </ContextProvider>,
  document.getElementById("root")
);
